// -----------------------------------------------------------------------------
// App configuration. Change the API base URL here — no .env file needed.
// For local backend, use: "http://localhost:5000/api"
// -----------------------------------------------------------------------------
export const API_BASE_URL = "https://trustcomply.mytrustlab.co.in/api";
